import { action, makeObservable, observable, toJS } from 'mobx';

import { ChunkServerType, IChunkModel } from '../types';

type TableChunkServerType = {
  has_header_row: boolean;
  rows: string[][];
};

const DEFAULT_ROWS = 2;
const DEFAULT_COLUMNS = 2;

export class TableChunkModel implements IChunkModel<TableChunkServerType> {
  rows: string[][] = [];
  hasHeaderRow = true;

  constructor() {
    makeObservable(this, {
      rows: observable,
      hasHeaderRow: observable,

      setCell: action.bound,
      addRow: action.bound,
      removeRow: action.bound,
      addColumn: action.bound,
      removeColumn: action.bound,
      toggleHeaderRow: action.bound,
    });
  }

  setCell(rowIndex: number, colIndex: number, html: string): void {
    this.rows[rowIndex][colIndex] = html;
  }

  addRow(): void {
    const columnsCount = this.rows[0]?.length || DEFAULT_COLUMNS;
    this.rows.push(new Array(columnsCount).fill(''));
  }

  removeRow(rowIndex: number): void {
    if (this.rows.length <= 1) {
      return;
    }
    this.rows.splice(rowIndex, 1);
  }

  addColumn(): void {
    this.rows.forEach((row) => row.push(''));
  }

  removeColumn(colIndex: number): void {
    if ((this.rows[0]?.length || 0) <= 1) {
      return;
    }
    this.rows.forEach((row) => row.splice(colIndex, 1));
  }

  toggleHeaderRow(): void {
    this.hasHeaderRow = !this.hasHeaderRow;
  }

  toJson(): TableChunkServerType {
    return toJS({
      has_header_row: this.hasHeaderRow,
      rows: this.rows,
    });
  }

  static fromJson({
    data,
  }: ChunkServerType<TableChunkServerType>): TableChunkModel {
    const model = new TableChunkModel();
    model.rows = data.rows;
    model.hasHeaderRow = data.has_header_row;

    return model;
  }

  static createDefault(): TableChunkModel {
    const model = new TableChunkModel();
    model.rows = Array.from({ length: DEFAULT_ROWS }, () =>
      new Array(DEFAULT_COLUMNS).fill('')
    );
    return model;
  }
}
